import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/css/style.css";
import "./assets/css/menu.css";
import "./assets/css/custom.css";
import "./assets/css/responsive.css";
import "./assets/css/home.css";
import "./assets/css/metro-buttons.css";
import "./index.css";
import "./assets/js/custom";
import "./assets/js/menu";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import './assets/css/translate.scss';
// import './assets/js/translate';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
